import React, { useState, useRef, useEffect } from "react";
import { Button, Input, Card, Tooltip, message } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import {
  deleteSourcesFromSupabase,
  saveSourcesToSupabase,
} from "../../../../Utils/SupabaseServices/TrafficSources";
import { FaTrash } from "react-icons/fa";

const TrackTraffic = (props: any) => {
  const {
    username,
    user_id,
    startDate,
    endDate,
    isYesterday,
    daysNumber,
    brand_color,
    trafficSourcesData,
    refetchTrafficSources,
  } = props;
  const [sources, setSources] = useState<any[]>(trafficSourcesData || []);
  const [duplicateWarning, setDuplicateWarning] = useState<number | null>(null);
  const [copiedIdx, setCopiedIdx] = useState<number | null>(null);

  // Helper to generate a unique id
  const generateId = () =>
    Date.now().toString() + Math.random().toString(36).substr(2, 9);

  const addSource = () => {
    setSources([
      ...sources,
      {
        unique_id: generateId(),
        source: "",
        url: `https://www.searchbubble.com/${username}?`,
      },
    ]);
  };

  const handleDelete = async (idx: number) => {
    setSources(sources.filter((_: any, i: number) => i !== idx));
    await deleteSourcesFromSupabase(user_id, sources[idx]);
    refetchTrafficSources();
  };

  const isDuplicate = (newName: string, currentIndex: number) => {
    return sources.some(
      (source, idx) =>
        idx !== currentIndex &&
        source.source.toLowerCase() === newName.toLowerCase()
    );
  };

  const handleChange = (e: any, idx: number) => {
    const updatedSources = [...sources];
    const newName = e.target.value;

    // Check for duplicates
    if (newName && isDuplicate(newName, idx)) {
      setDuplicateWarning(idx);
      message.warning("This source name already exists");
    } else {
      setDuplicateWarning(null);
    }

    updatedSources[idx].source = newName;
    updatedSources[
      idx
    ].url = `https://www.searchbubble.com/${username}?${encodeURIComponent(
      newName.toLowerCase().replace(/\s+/g, "-")
    )}`;
    setSources(updatedSources);
  };

  const saveTimeout: any = useRef();
  const saveSources = () => {
    const filteredSources = sources?.filter((src) => src.source.trim() !== "");
    saveSourcesToSupabase(user_id, filteredSources, username);
    refetchTrafficSources();
  };
  useEffect(() => {
    if (!user_id) return;

    clearTimeout(saveTimeout.current);
    saveTimeout.current = setTimeout(() => {
      saveSources();
    }, 400);

    return () => clearTimeout(saveTimeout.current);
  }, [sources, user_id]);
  useEffect(() => {
    return () => {
      clearTimeout(saveTimeout.current);
      saveSources(); // Flush save on unmount
    };
  }, []);

  // useEffect(() => {
  //   if (!user_id) return;
  //   clearTimeout(saveTimeout.current);
  //   saveTimeout.current = setTimeout(() => {
  //     const filteredSources = sources?.filter(
  //       (src) => src.source.trim() !== ""
  //     );
  //     saveSourcesToSupabase(user_id, filteredSources, username);
  //     refetchTrafficSources();
  //   }, 1000);
  //   return () => clearTimeout(saveTimeout.current);
  // }, [sources, user_id]);

  const handleShare = (url: string, idx: number) => {
    navigator.clipboard.writeText(url);
    setCopiedIdx(idx);
    setTimeout(() => setCopiedIdx(null), 1000);
  };

  const shareButton = (source: any, idx: number) => {
    const shareUrl = `https://www.searchbubble.com/${username}?${encodeURIComponent(
      source.source.toLowerCase().replace(/\s+/g, "-")
    )}`;
    return (
      <Tooltip title="Copied!" placement="bottom" open={copiedIdx === idx}>
        <Button
           className="sharelink-btn"
          // style={{ marginLeft: 16 }}
          onClick={() => handleShare(shareUrl, idx)}

        >
          Share Link
        </Button>
      </Tooltip>
    );
  };

  return (
    <>
      <style>{`
        @media (max-width: 991px) {
          .tt-card-body {
            flex-direction: column !important;
            align-items: stretch !important;
          }
          .tt-btn-group {
            flex-direction: column !important;
            align-items: stretch !important;
          }
          .tt-btn-group button {
            width: 100% !important;
            margin-left: 0 !important;
            margin-top: 8px !important;
          }
             .tt-btn-group button:hover {
            background:none !important;
            border:none !important;
          }
        }
        @media (min-width: 992px) {
          .tt-card-body {
            flex-direction: row !important;
            align-items: center !important;
          }
          .tt-btn-group {
            flex-direction: row !important;
            align-items: center !important;
            justify-content: flex-end !important;
          }
          .tt-btn-group button {
            width: auto !important;
            margin-left: 8px !important;
            margin-top: 0 !important;
          }
          .tt-btn-group button:hover {
            background:none !important;
            border:none !important;
          }
        }
      `}</style>
      <div
        style={{
          // margin: "40px auto",
          background: "#fafbfc",
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
          padding: 32,
          border: "1px solid #ececec",
          maxWidth: 700,
          width: "100%",
        }}
      >
        <h2 style={{ fontWeight: 700, fontSize: 24, marginBottom: 4 }}>
          Track Traffic
        </h2>
        <div style={{ color: "#888", marginBottom: 24 }}>
          Monitor and manage your traffic sources with trackable links
        </div>
        {sources.map((source: any, idx: number) => (
          <Card
            key={source.unique_id}
            style={{
              marginBottom: 16,
              border: "1px solid #e5e7eb",
              borderRadius: 8,
              background: "#fff",
              width: "100%",
            }}
            bodyStyle={{
              padding: 16,
              display: "flex",
              gap: 16,
            }}
            className="tt-card"
          >
            <div
              className="tt-card-body"
              style={{ display: "flex", gap: 16, flex: 1, minWidth: 0 }}
            >
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontWeight: 600, marginBottom: 4 }}>
                  Source Name
                </div>
                <Input
                  value={source?.source}
                  style={{
                    marginBottom: 8,
                    background: "#f5f6fa",
                    borderColor:
                      duplicateWarning === idx ? "#ff4d4f" : undefined,
                    width: "100%",
                  }}
                  onChange={(e) => handleChange(e, idx)}
                  status={duplicateWarning === idx ? "error" : undefined}
                />
                {duplicateWarning === idx && (
                  <div
                    style={{ color: "#ff4d4f", fontSize: "12px", marginTop: 4 }}
                  >
                    This source name already exists
                  </div>
                )}
                <p style={{ wordBreak: "break-all", marginBottom: 0 }}>
                  {source?.url}
                </p>
              </div>
              <div
                className="tt-btn-group"
                style={{ display: "flex", gap: 8, minWidth: 0 }}
              >
                {shareButton(source, idx)}
                <Button
                  icon={<FaTrash />}
                  style={{ border: "none", color: "grey" }}
                  onClick={() => handleDelete(idx)}
                />
              </div>
            </div>
          </Card>
        ))}
        <Button
          type="dashed"
          block
          style={{
            marginTop: 16,
            borderRadius: 8,
            height: 48,
            fontWeight: 600,
            fontSize: 16,
            background: "#f5f6fa",
          }}
          onClick={addSource}
        >
          + Add New Source
        </Button>
      </div>
    </>
  );
};

export default TrackTraffic;
